module.exports = __webpack_public_path__ + "img/search.dd0e163c.svg";